import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MaskedLink } from '../../../../../../../../../components/internal/MaskedLink/index.js';
import { DESTINATION_TYPE_DESTINATION, PROMO_LINK_ITEM } from '../../../../../../../../../components/SearchForm/components/DestinationField/models.js';
import { Content } from '../../../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/components/Item/components/Content/index.js';
import { Link } from '../../../../../../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../../../../../../utils/directus.js';
export const Item = ({
  item,
  onSelectKeyword
}) => {
  const directusUrl = useDirectusImageUrl(`${item.image?.id}.${item.image?.extension}`);
  const imageUrl = item.image?.type === 'directus' ? directusUrl : item.image?.url;
  const handleLinkClicked = () => {
    const mappedKeyword = {
      id: PROMO_LINK_ITEM,
      keyword: item.text,
      type: DESTINATION_TYPE_DESTINATION
    };
    onSelectKeyword(mappedKeyword);
  };
  const handleClick = () => {
    const mappedKeyword = {
      id: item.keyword,
      keyword: item.text,
      type: DESTINATION_TYPE_DESTINATION
    };
    // @ts-expect-error TS2345
    onSelectKeyword(mappedKeyword);
  };
  if (item.url) {
    return item.masked ? _jsx(MaskedLink, {
      href: item.url,
      target: item.target,
      children: _jsx(Content, {
        item: item,
        isLink: true,
        imageUrl: imageUrl,
        onClick: handleLinkClicked
      })
    }) : _jsx(Link, {
      href: item.url,
      target: item.target,
      children: _jsx(Content, {
        item: item,
        isLink: true,
        imageUrl: imageUrl,
        onClick: handleLinkClicked
      })
    });
  }
  if (item.keyword) {
    return _jsx(Content, {
      item: item,
      onClick: handleClick,
      imageUrl: directusUrl
    });
  }
};